import { POIList } from "@local-logic/elements-react";
import React, { useContext } from "react";
import { GoogleMapContext } from "~/sdks/LocalContent/Map/GoogleMap/context";
import { useLocalContent } from "~/sdks/LocalContent/context";
import { useSchools } from "~/sdks/LocalContent/features/useSchools";
import { getCenterWithOffset } from "~/utils/formatters/getCenterWithOffset";

interface SchoolsProps {
  score: "primary_schools" | "high_schools";
}

const GoogleSchools = ({ score }: SchoolsProps) => {
  const { data } = useSchools();
  const { activePOI, setActivePOI, hoveredPOI, setHoveredPOI } =
    useLocalContent();
  const { googleMapRef } = useContext(GoogleMapContext);

  if (!data) {
    return null;
  }

  return (
    <POIList.Root
      options={{
        type: "school",
        data: data?.[score],
        activePOI,
        hoveredPOI,
      }}
      onChange={(e) => {
        if (e.type === "poi-click") {
          const s = e.data;
          setActivePOI(s);

          if (s && googleMapRef) {
            googleMapRef.setZoom(20);

            const newCenter = getCenterWithOffset({
              map: googleMapRef,
              lat: s.lat,
              lng: s.lng,
              xPixelOffset: 190,
              yPixelOffset: 0,
            });

            if (newCenter) googleMapRef.setCenter(newCenter);
          }
        }

        if (e.type === "poi-hover") {
          setHoveredPOI(e.data);
        }
      }}
    />
  );
};

export default GoogleSchools;
